import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { IDataProps } from '~/src/features/agent/data';

import * as ST from './styled';

interface IProps {
    blockData: IDataProps,
}

const ContentBlock = ({ blockData }: IProps): JSX.Element => {
    const { id, blockSize, title, desc, imgPath, webpPath, imgAlt, mobile, gifPath, media } = blockData;

    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    const isOnlyImage = !title || !desc;

    return (
        <ST.BlockWrapper
            size={blockSize}
            area={`${blockSize}-${id}`}
            isOnlyImage={isOnlyImage}
            id={`block-${id}`}
        >
            {(title && desc) && <ST.ContentBlock>
                <ST.BlockTitle as={'h2'} data-test='block-title' dangerouslySetInnerHTML={{ __html: title }}/>
                <ST.BlockDesc dangerouslySetInnerHTML={{ __html: desc }}/>
            </ST.ContentBlock>}
            <ST.MediaBlock>
                {webpPath
                    ? (isMobile && mobile)
                        ? <WebpImage urlWebp={mobile.webpPath}>
                            <ST.BlockImage
                                src={mobile.imgPath}
                                alt={imgAlt}
                                data-test='block-img'
                            />
                        </WebpImage>
                        : <>
                            <WebpImage urlWebp={webpPath}>
                                <ST.BlockImage
                                    src={imgPath}
                                    alt={imgAlt}
                                    data-test='block-img'
                                />
                            </WebpImage>
                            {gifPath && (
                                <ST.TypingAnimationBlock>
                                    <img
                                        src={gifPath}
                                        alt='Анимация набора текста в чате'
                                        data-test='block-animation'
                                    />
                                </ST.TypingAnimationBlock>
                            )}
                        </>
                    : <ST.BlockVideo autoPlay loop playsInline muted data-test='block-video'>
                        <source src={media?.webm} type='video/webm'></source>
                        <source src={media?.mp4} type='video/mp4'></source>
                        <source src={media?.ogv} type='video/ogg'></source>
                    </ST.BlockVideo>
                }
            </ST.MediaBlock>
        </ST.BlockWrapper>
    );
};

export default ContentBlock;
